import styled from '@emotion/styled'
import { tokens } from '../../theme.js'

const colors = tokens.colors
const fontFamily = tokens.fonts.body

export const ProjectHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 16px 32px;
  background: ${colors.white};
  border-bottom: 1px solid ${colors.sectionDivider};
`
export const ProjectColumns = styled.div`
  position: relative;
  display: flex;
  flex: 1;
  min-height: 0;
`
export const ProjectMain = styled.main`
  flex: 1;
  min-width: 0;
  overflow-y: auto;
  padding: 24px 32px;
  background: ${colors.white};
  outline: ${p => (p.$drag ? `2px dashed ${colors.primary}` : 'none')};
  outline-offset: -8px;
`
export const SortSelect = styled.select`
  appearance: none;
  -webkit-appearance: none;
  height: 28px;
  padding: 0 14px 0 30px;
  border-radius: ${tokens.borderRadius.button};
  border: 0.775px solid ${colors.secondaryButton.border};
  background: ${colors.secondaryButton.background};
  font: 500 14px/1 ${fontFamily};
  color: ${colors.secondaryButton.text};
  cursor: pointer;
  &:hover {
    background: ${colors.secondaryButton.hover};
  }
  &:focus {
    outline: none;
    border-color: ${colors.primary};
  }
`
export const SortLabel = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 8px;
`
export const ProjectControls = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 9px;
  margin-left: auto;
  flex: 0 0 auto;
`
export const ActiveViewChip = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 28px;
  padding: 0 14px;
  border-radius: ${tokens.borderRadius.button};
  background: ${colors.primaryExtraLight};
  color: ${colors.text.body};
  font: 500 13px/1 ${fontFamily};
  white-space: nowrap;
  & .MuiSvgIcon-root {
    font-size: 15px;
    color: ${colors.primary};
  }
  & > span {
    color: ${colors.text.muted};
  }
  & > button {
    border: none;
    background: transparent;
    padding: 0;
    cursor: pointer;
    color: ${colors.text.link};
    font: 500 13px/1 ${fontFamily};
  }
  & > button:hover {
    color: ${colors.text.linkDisabled};
  }
`
